class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-recently-viewed-list]');
    this.render();
  }

  render() {
    const excludeId = this.dataset.excludeProductId ? parseInt(this.dataset.excludeProductId, 10) : null;
    const limit = parseInt(this.dataset.limit || '6', 10);

    let items = [];
    try {
      items = JSON.parse(window.localStorage.getItem('seeragam:recently-viewed') || '[]');
    } catch (e) {
      items = [];
    }

    if (excludeId) {
      items = items.filter((item) => item.id !== excludeId);
    }

    items = items.slice(0, limit);

    if (!items.length || !this.list) {
      this.hidden = true;
      return;
    }

    this.list.innerHTML = items
      .map((item) => {
        const title = this.escapeHtml(item.title);
        return `
          <li class="recently-viewed__item">
            <a href="${this.escapeHtml(item.url)}" class="recently-viewed__link">
              ${
                item.image
                  ? `<img src="${this.escapeHtml(item.image)}" alt="${title}" width="160" height="160" loading="lazy" class="recently-viewed__image">`
                  : ''
              }
              <span class="recently-viewed__title">${title}</span>
              <span class="recently-viewed__price">${this.formatMoney(item.price)}</span>
            </a>
          </li>
        `;
      })
      .join('');

    this.hidden = false;
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  formatMoney(cents) {
    const amount = (cents || 0) / 100;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return 'Rs. ' + Math.round(amount);
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
